import React from "react"
import { Box, Collapse } from "@material-ui/core"
import { Blockquote } from "."
import { Icon } from ".."

const MissingLocationAccessBlockquote = ({ show = false, subject = "process", mb = 3 }) => (
  <Collapse in={show}>
    <Box mb={mb}>
      <Blockquote
        icon={<Icon name="warning" />}
        title={`You cannot edit this ${subject}`}
        body={`You cannot edit this ${subject} as it is assigned to one or more location that you don't have access to. Please contact your system administrator.`}
        color="warning"
      />
    </Box>
  </Collapse>
)

export { MissingLocationAccessBlockquote }
